import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import { countryModelGet, } from '../../models/countries/country';
import {
    responseGet, globalSettings, styles, buttonProcessGet, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'CountriesAddEdit';

const { app, collections: dbColle, icons, labels, messages, } = globalSettings;
const { properties: dbProps, } = dbColle;
const { html, } = globalSettings?.react;
const { backend, } = app;

export default function CountriesAddEdit({
    $ = {},
    auth = {},
    country = countryModelGet({}),
    setCountry = () => { },
    dtId = '',
    dtObj = {},
    dtRowIndex = 0,
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [numericError, setNumericError] = useState('');
    const [alphaCode3Error, setAlphaCode3Error] = useState('');
    const [alphaCode2Error, setAlphaCode2Error] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnCountryModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnCountryModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnCountryModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // inactive: {
            //     id: 'chkCountryModalEnable',
            //     className: 'icheck-primary d-inline',
            // },
            // inactiveReadOnly: {
            //     id: 'chkCountryModalReadOnly',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCountryesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCountryesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCountryesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCountryesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCountryesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCountryesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCountryesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCountryesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoCountryModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoCountryModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoCountryModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            description: {
                id: 'inputCountryModalDescription',
                className: 'form-control',
            },
            alphaCode02: {
                id: 'inputCountryModalAlphaCode02',
                className: 'form-control',
            },
            alphaCode03: {
                id: 'inputCountryModalAlphaCode03',
                className: 'form-control',
            },
            numeric: {
                id: 'inputCountryModalNumeric',
                className: 'form-control',
            },
        },
        selects: {
            // coins: {
            //     id: 'selCountryModalCoins',
            //     className: 'form-select',
            // },
        },
        spinners: {
            save: {
                id: 'spCountryModalSave',
                className: '',
            },
            back: {
                id: 'spCountryModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (country)
    const countryAddPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'countryAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormDataAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                country: country,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCountries}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            country = response?.result || {};

            $(`#${dtId}`)?.DataTable()?.row?.add([
                country?.description,
                country?.alphaCode2,
                country?.alphaCode3,
                country?.numeric,
                buttonProcessGet({
                    id: country?.id,
                    description: country?.description,
                    showDetails: false,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion data save

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const countryEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'countryAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormDataAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                country: country,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCountries}/${country?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            country = response?.result || {};

            $(`#${dtId}`)?.DataTable()?.row(dtRowIndex)?.data?.([
                country?.description,
                country?.alphaCode2,
                country?.alphaCode3,
                country?.numeric,
                buttonProcessGet({
                    id: country?.id,
                    description: country?.description,
                    showDetails: false,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion data save

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (country)

    //#region methods (others)
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSet = ({
        property = '',
        value = '',
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            setCountry({
                ...country,
                [property]: value,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
    }

    const validateFormDataAsync = ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region methods
            if (isUndNullEmp({ data: country?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: country?.alphaCode2, subMethod: currentMethod, })?.result) {
                setAlphaCode2Error(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (country?.alphaCode2.length !== 2) {
                setAlphaCode2Error(`${messages?.thisFieldRequired?.[languageObj?.id]}. 2 ${labels?.characters?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: country?.alphaCode3, subMethod: currentMethod, })?.result) {
                setAlphaCode3Error(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (country?.alphaCode3.length !== 3) {
                setAlphaCode3Error(`${messages?.thisFieldRequired?.[languageObj?.id]}. 3 ${labels?.characters?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: country?.numeric, subMethod: currentMethod, })?.result) {
                setNumericError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (country?.numeric.length !== 3) {
                setNumericError(`${messages?.thisFieldRequired?.[languageObj?.id]}. 3 ${labels?.characters?.[languageObj?.id]}`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const errorsDefaultSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'errorsDefaultSet';
        let response = responseGet();
        try {
            setNumericError('');
            setAlphaCode3Error('');
            setAlphaCode2Error('');
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.alphaCode02?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.selects?.coins?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.alphaCode03?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.numeric?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
    }, [showModal]);
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.country?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.countriesLogo}></img> - {labels?.country?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : (processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase())})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ?
                countryAddPostAsync({ e: e, subMethod: 'form - onSubmit' }) :
                countryEditPostAsync({ e: e, subMethod: 'form - onSubmit' })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processType === 0 ? countryAddPostAsync(e) : countryEditPostAsync(e)}> */}

                    {/* <div className='card-header'>
                                <h6 className='card-title'><img alt='country' src={globalSettings?.images?.countriesLogo} style={styles?.cardHeaderLogo}>
                                </img> - {labels?.country?.[languageObj?.id]}
                                </h6>
                            </div> */}

                    {/* <div className='card-body'> */}
                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.description?.id}
                                className={controls?.inputs?.description?.className}
                                placeholder={labels?.name?.[languageObj?.id]}
                                //autoFocus
                                onChange={(e) => formDataSet({
                                    property: dbProps?.description,
                                    value: e?.target?.value,
                                    subMethod: 'input - description'
                                })}
                                onFocus={() => setDescriptionError('')}
                                value={country?.description || ''}
                                tooltip='tooltip'
                                title={labels?.name?.[languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={icons?.spellCheck} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                    </div>
                    <div className='row'>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.alphaCode02?.id}
                                        className={controls?.inputs?.alphaCode02?.className}
                                        placeholder={labels?.alphaCode2}
                                        onChange={(e) => formDataSet({
                                            property: dbProps?.alphaCode2,
                                            value: e?.target?.value,
                                            subMethod: 'input - alphaCode2',
                                        })}
                                        onFocus={() => setAlphaCode2Error('')}
                                        value={country?.alphaCode2 || ''}
                                        tooltip='tooltip'
                                        title={labels?.alphaCode2} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.spellCheck} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(alphaCode2Error)}</div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.alphaCode03?.id}
                                        className={controls?.inputs?.alphaCode03?.className}
                                        placeholder={labels?.alphaCode3}
                                        onChange={(e) => formDataSet({
                                            property: dbProps?.alphaCode3,
                                            value: e?.target?.value,
                                            subMethod: 'input - alphoCode3',
                                        })}
                                        onFocus={() => setAlphaCode3Error('')}
                                        value={country?.alphaCode3 || ''}
                                        tooltip='tooltip'
                                        title={labels?.alphaCode3} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.spellCheck} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(alphaCode3Error)}</div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.numeric?.id}
                                        className={controls?.inputs?.numeric?.className}
                                        placeholder={labels?.numeric}
                                        onChange={(e) => formDataSet({
                                            property: dbProps?.numeric,
                                            value: e?.target?.value,
                                            subMethod: 'input - numeric',
                                        })}
                                        onFocus={() => setNumericError('')}
                                        value={country?.numeric || ''}
                                        tooltip='tooltip'
                                        title={labels?.numeric} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.sortNumericUpAlt} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(numericError)}</div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/* <div className='card-footer'>
                                <div className='form-group text-right'>
                                    <button className='btn btn-outline-warning mx-1'
                                        tooltip='tooltip'
                                        title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                        type='submit'>
                                        <i className={icons?.save}></i>
                                    </button>
                                    <button className='btn btn-outline-success'
                                        tooltip='tooltip'
                                        title={labels?.close?.[languageObj?.id]}
                                        type='reset'
                                        onClick={() => defaultValueSetAsync(true)}>
                                        <i className={icons?.arrowCircleLeft}></i>
                                    </button>
                                </div>
                            </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}